import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "../modules/Breadcrumbs";
import "./queries.scss";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DropSelect from "../modules/AutoComplete";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import BtnSet from "./BtnSet";
import StaticItem from "../modules/StaticItem";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addQueryDocs, setCaseId } from "./redux/actions";
import Button from "../modules/Button";
import { addDocInfo } from "../LoginPage/redux/actions";
import GradientLoader from "../modules/Loader";
import ModalComponent from "../modules/Modal";
import tick from "../../Assets/svg/green-bg-tick.svg";
import { useNavigate } from "react-router-dom";

function UpdateQueries(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDoc, showDoc] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [isLoader, showLoader] = useState(false);
  const queries = useSelector((state) => state.queries);
  const queryDocs = useSelector((state) => state.queries.queryDocs);
  const [docList, setDocList] = useState([]);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });

  const [err, setErr] = useState("");
  const [query, setQuery] = useState({ cat: "", details: "", doc: null });
  const [btn, setBtn] = useState(true);
  const tokenData = useSelector((state) => state.tokens.tokens);

  console.log("query", query);
  const viewField = () => {
    // getDocs();
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/view-queries");
    navigate("/application/help/view-queries");
  };
  const sendQuery = async () => {
    const formData = new FormData();
    let data = {
      userType: "STUDENT",
      salesForceStudentCaseId: null,
      salesForceStudentCaseQueryId: null,
      comment: query.details,
      // caseCategory: query.cat,
      // caseDetails: query.details,
      // applicationId: tokenData.appId,
      // caseStatus: "Assigned",
      // caseDocument: query.doc,
      // studentCaseQueries: [],
    };

    // formData.append("salesForceStudentCaseId", null);
    // formData.append("caseCategory", query.cat);
    // formData.append("caseDetails", query.details);
    // formData.append("applicationId", tokenData.appId);
    // formData.append("caseStatus", "Assigned");
    // formData.append("caseDocument", query.doc);
    // formData.append("studentCaseQueries", []);

    console.log("before", data);
    try {
      const send = await api.postCommentOnQuery(
        data,
        tokenData.token,
        queries.caseId
      );
      return send;
    } catch (error) {
      console.log("Error", error);
      // console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };

  const preSendQuery = async () => {
    const formData = new FormData();
    let data = {
      userType: "STUDENT",
      salesForceStudentCaseId: null,
      salesForceStudentCaseQueryId: null,
      comment: query.details,
    };

    console.log("before", data);
    try {
      const send = await sendQuery();
      console.log("query", send);
      dispatch(setCaseId(send.data.caseNumber));
      if (send.statusCode == 200) {
        props.showModal("Your Query submitted Successfully!");
        let url = GetBaseUrl(window.location.href);
        // window.location.replace(url + "/application/help/view-queries");
        navigate("/application/help/view-queries");
      } else {
        return "failed";
      }
    } catch (error) {
      // setErr("Sorry! Something Went Wrong");
      setTimeout(() => setErr(""), 3000);
      // console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };

  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      showModal({
        ...isModal,
        show: true,
        msg: "File with double extensions is not allowed.",
      });
      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const addDoc = (e) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
      ".doc",
      ".docx",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (e) {
      let isFormat = false;
      for (let i in allowedTypes) {
        if (e.type === allowedTypes[i]) {
          isFormat = true;
        }
      }
      if (!isFormat) {
        e = null;
        console.log("doc.type", e.type);
        alert("Only PDF, JPEG, PNG, and Word files are allowed.");
        //   setDoc(null); // Clear the file input
      } else if (e !== null && e.size / 1024 / 1024 > 2) {
        e = null;
        alert(" File size exceeds the maximum upload size limit.");
        // showErr(true)
        // setTimeout(() => showErr(false), 3000);
      }
    }
    e = validateFileName(e);
    if (e) {
      setQuery({ ...query, doc: e });
    }
    // return e;
  };

  const getDocs = async () => {
    console.log("in get Docs", queries);
    const docs2 = await api.getDocuments(
      "cases",
      tokenData.appId,
      tokenData.token
    );
    console.log("in get Docs result", docs2);
    setDocList(docs2.data);
    dispatch(addQueryDocs(docs2.data));
  };
  const delDoc = async (type, e) => {
    e = validateFileName(e);
    let file;
    if (docs[type]) {
      file = docs[type];
    }
    if (e) {
      try {
        setUploading(true);

        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", `caseDocument`);
        formData.append("fileType", e.type.split("/")[1]);
        if (file) {
          formData.append("id", file.id);
        }
        const result = await api.uploadDocument(
          "cases",
          queries.caseId,
          tokenData.token,
          formData
        );
        console.log("result", result, queries);
        if (result?.statusCode == 200) {
          let url = GetBaseUrl(window.location.href);
          window.location.replace(url + "/application/help/view-queries");
          getDocs();
          showLoader(false);
        }
        setUploading(false);
      } catch (err) {
        //alert("Sorry! Something went wrong, Please try again.");

        console.error("Error deleting document:", err);
        setUploading(false);
      }
    }
  };
  const handleUpload = async (item) => {
    item = validateFileName(item);
    if (item) {
      try {
        showLoader(true);
        setUploading(true);

        const formData = new FormData();
        formData.append("file", item);
        formData.append("name", item.name);
        formData.append("size", item.size);
        formData.append("documentType", `caseDocument`);
        formData.append("fileType", item.type.split("/")[1]);

        const result = await api.uploadDocument(
          "cases",
          queries.caseId,
          tokenData.token,
          formData
        );
        console.log("result", result, queries);
        if (result.statusCode == 200) {
          showDoc(true);
          props.showModal("Your Document has been uploaded successfully!");
          getDocs();
          showLoader(false);
          // let url = GetBaseUrl(window.location.href);
          // window.location.replace(url + "/application/help/view-queries");
        }
        setUploading(false);
      } catch (error) {
        console.error("Error uploading document:", error);
        setUploading(false);
        showLoader(false);
      }
    }
  };

  const setQueryData = (e) => {
    setQuery({
      ...query,
      details: e,
    });
  };
  useEffect(() => {
    let btn1 = true;
    for (let i in query) {
      if (query[i]?.length === 0) {
        btn1 = false;
      }
    }
    setBtn(btn1);
  }, [query]);
  console.log("queries", queries, query, docList);
  return (
    <div className=" raise">
      <div className="bc">
        <BreadCrumbComponent list={["Help", "Queries", "Update Query"]} />
      </div>
      <div className="raise-heading">
        <div className="form-title">Update Query</div>
        <div onClick={viewField} className="left-btn upload-top-text">
          Back to Queries
          <NavigateNextIcon fontSize="small" />
        </div>
      </div>
      <div className="cred-fields">
        <Input
          onChange={(e) => setQueryData(e.replace(/[^a-zA-Z0-9. ]/g, ""))}
          value={query?.details}
          placeholder={"Add details here"}
          multiline={true}
        />

        {/* {!query.doc  ? (
          <div className="doc-item">
            <StaticItem
              onChange={() => {}}
              type={"doc"}
              title={"Current Address Proof"}
              docUrl={docs[`currentAddressProof`]?.documentUrl}
              value={docs[`currentAddressProof`]?.name}
              size={Math.floor(docs[`currentAddressProof`]?.size / 1024)}
            />
          </div>
        ) : (
          <div className="file-upload-container">
            <DocUpload
              onChange={(e) => addDoc(e)}
              footerText={"Supported formats: Word Doc, PDF, JPEG, PNG"}
              noTooltip={true}
              placeholder={"Upload screenshot of error (if applicable)"}
            />
            {doc && (
              <Button
                className="upload-button"
                onClickHandler={() => handleUpload()}
                disabled={uploading}
                value={uploading ? <span className="spinner"></span> : "Upload"}
                type={"contained"}
              />
            )}
          </div>
        )} */}

        {!isDoc ? (
          <>
            <DocUpload
              onChange={(e) => handleUpload(e)}
              footerText={"Supported formats: Word Doc, PDF, JPEG, PNG"}
              noTooltip={true}
              // value={
              //   queryDocs?.data?.[queries?.caseId]
              //     ? queryDocs.data[queries.caseId][
              //         queryDocs.data[queries.caseId].length - 1
              //       ]
              //     : queryDocs?.[queries?.caseId] &&
              //       queryDocs[queries.caseId].length > 0
              //     ? queryDocs[queries.caseId][
              //         queryDocs[queries.caseId].length - 1
              //       ]
              //     : null
              // }
              placeholder={"Upload screenshot of error (if applicable)"}
            />
          </>
        ) : (
          <div className="doc-list">
            <div className="doc-item">
              <StaticItem
                onChange={() => {}}
                onDelete={(e) => handleUpload(e)}
                isEditable={true}
                type={"doc"}
                title={"Current Address Proof"}
                doc={
                  queryDocs?.data?.[queries?.caseId]
                    ? queryDocs.data[queries.caseId][
                        queryDocs.data[queries.caseId].length - 1
                      ]
                    : queryDocs?.[queries?.caseId] &&
                      queryDocs[queries.caseId].length > 0
                    ? queryDocs[queries.caseId][
                        queryDocs[queries.caseId].length - 1
                      ]
                    : null
                }
                docUrl={
                  queryDocs?.data?.[queries?.caseId]
                    ? queryDocs.data[queries.caseId][
                        queryDocs.data[queries.caseId].length - 1
                      ]?.documentUrl
                    : queryDocs?.[queries?.caseId] &&
                      queryDocs[queries.caseId].length > 0
                    ? queryDocs[queries.caseId][
                        queryDocs[queries.caseId].length - 1
                      ]?.documentUrl
                    : null
                }
                value={
                  queryDocs?.data?.[queries?.caseId]
                    ? queryDocs.data[queries.caseId][
                        queryDocs.data[queries.caseId].length - 1
                      ]?.name
                    : queryDocs?.[queries?.caseId] &&
                      queryDocs[queries.caseId].length > 0
                    ? queryDocs[queries.caseId][
                        queryDocs[queries.caseId].length - 1
                      ]?.name
                    : null
                }
                size={
                  queryDocs?.data?.[queries?.caseId]
                    ? Math.floor(
                        queryDocs.data[queries.caseId][
                          queryDocs.data[queries.caseId].length - 1
                        ]?.size / 1024
                      )
                    : queryDocs?.[queries?.caseId] &&
                      queryDocs[queries.caseId].length > 0
                    ? Math.floor(
                        queryDocs[queries.caseId][
                          queryDocs[queries.caseId].length - 1
                        ]?.size / 1024
                      )
                    : null
                }
              />
            </div>
          </div>
        )}
      </div>
      {/* {(query.doc?.name || queryDocs[queries.caseId]?.name) && (
     
      )} */}
      {err && <div>{err}</div>}
      <BtnSet
        onClick={() => preSendQuery()}
        isBtn={query.cat === "" || query.details === ""}
        type={"query"}
        btnDisable={query.details === ""}
        btnText={"Submit"}
      />
      <ModalComponent
        className={"loader-model"}
        show={isLoader}
        // handleClose={() => CancelData()}
        // title={ModalData.title}
        // content={ModalData.desc}
      >
        <GradientLoader />
      </ModalComponent>
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been submitted successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
            {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

          {/* <div className="modal-btn-set">
              <Button
                onClickHandler={() => CancelData()}
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Yes, Submit" :ModalData.type === "cancel" ?"Yes": "Okay"}
              />
            </div> */}
        </ModalComponent>
      )}
    </div>
  );
}

export default UpdateQueries;
